import first from "lodash/first";
import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeAroundMorningStudioPrimaryContentItemContent$key } from "~/queries/__generated__/homeAroundMorningStudioPrimaryContentItemContent.graphql";

import {
  Container,
  Content,
  CoverImage,
  Headline,
  SponsorContainer,
  SponsorName,
  SponsorType,
  StyledEntityLink,
} from "./styles";

export type Props = {
  reference: homeAroundMorningStudioPrimaryContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeAroundMorningStudioPrimary = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeAroundMorningStudioPrimaryContentItemContent on Content {
          entityId
          topics {
            sponsor {
              name
              type
            }
          }
          ...entityLink
        }
      `,
      reference_,
    );

    const sponsor = first(content?.topics)?.sponsor;
    const sponsorName = sponsor?.name;
    const sponsorType = sponsor?.type;

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
          <CoverImage>
            {provider.coverImage({
              responsiveVariants: {
                desktopUp: "size540x360",
                homeDesktopUp: "size540x360",
                mobileUp: "size540x360",
                tabletUp: "size540x360",
              },
              withCaption: true,
            })}
          </CoverImage>
          <Content>
            <Headline>
              {provider.headline({
                preferSocialHeadline: true,
                useContentSponsorStyle: false,
              })}
            </Headline>
          </Content>
        </StyledEntityLink>
        <SponsorContainer>
          <SponsorType>{sponsorType}</SponsorType>
          <SponsorName>{sponsorName}</SponsorName>
        </SponsorContainer>
      </Container>
    );
  },
);

ContentItemHomeAroundMorningStudioPrimary.displayName = "ContentItemHomeAroundMorningStudioPrimary";
